import React from 'react';

interface AuthButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  loading?: boolean;
  loadingText?: string;
}

export function AuthButton({ 
  children, 
  variant = 'primary', 
  loading = false,
  loadingText,
  className = '',
  ...props 
}: AuthButtonProps) {
  const baseStyles = "w-full px-4 py-3 rounded-xl font-medium transition-all duration-300 ease-in-out";
  const variants = {
    primary: "bg-gradient-to-r from-amber-500/90 to-amber-600/90 hover:from-amber-500 hover:to-amber-600 text-white shadow-lg shadow-amber-600/20 hover:shadow-amber-600/30 backdrop-blur-sm disabled:opacity-50",
    secondary: "border border-white/20 bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      disabled={loading}
      {...props}
    >
      {loading ? (
        <div className="flex items-center justify-center gap-2">
          <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
          {loadingText || 'Loading...'}
        </div>
      ) : children}
    </button>
  );
}